import React from "react";

import classNames from "classnames";

const InactiveUpload = ({ upload }) => {
    let text;
    let showRemoveButton = false;

    switch (upload.state) {
        // INITIAL
        case 0:
        case 11:
            text = "Awaiting moderation";
            break;
        // APPROVED
        case 1:
            text = "This icon is being curated";
            break;
        // UNSAVED this doesn't make sense
        case 4:
            text = "This icon hasn't been submitted yet";
            break;
        // FLAGGED
        case 5:
            text = "This icon is being reviewed";
            break;
        // DENIED
        case 6:
            text = "This icon is being curated";
            break;
        // FLAGGED WITH REASON
        case 7:
            text = "This icon was flagged";
            showRemoveButton = true;
            break;
        // NEW DENIED
        case 8:
            text = "This icon was denied";
            showRemoveButton = true;
            break;
    }

    return (
        <li
            className={classNames("icon pending flipper", {
                denied: upload.dateDenied
            })}
        >
            <div className="front">
                <ul className="icon-actions">
                    {showRemoveButton ? (
                        <button
                            type="button"
                            title="Remove Icon"
                            className="flip-card ui_close"
                            data-icon-id={upload.id}
                            data-url="/upload/delete_upload"
                        />
                    ) : null}
                    <button
                        type="button"
                        title="More Info"
                        className="more-information ui_information"
                        data-icon-id={upload.id}
                        data-url={`/${upload.uploader.username}/upload/${upload.id}/information`}
                    />
                </ul>
                <a>
                    <img
                        src={upload.svg}
                        alt={`${upload.dateDenied ? "Denied" : "Pending"} Icon`}
                    />
                </a>
                <footer>
                    <h3>{text}</h3>
                </footer>
            </div>
            <div className="back">
                <div className="delete-confirmation">
                    <a
                        href="#"
                        className="delete-icon button ui_close slide-in-icon"
                        data-icon-id={upload.id}
                        data-url="/upload/delete_upload/"
                    >
                        <span>Delete</span>
                    </a>
                    <a href="#" className="nevermind">
                        <span>Nevermind</span>
                    </a>
                </div>
            </div>
        </li>
    );
};

export default InactiveUpload;
